export default __webpack_public_path__ + "static/banner-insider-tips-for-wedding-planning-eef041b87ef58da7624d35631ce6a42e.jpg";